import React from "react";

export default class InformationArea extends React.Component {
  render() {
    return (
      <div>
        <p>{this.props.info.title}</p>
        <ul>
          {this.props.info.textBlock
            .filter((text) => text)
            .map((text) => {
              if (!text) {
                return <></>;
              }
              return <li key={text}>{text}</li>;
            })}
        </ul>
      </div>
    );
  }
}
